import { Order } from "models/propTypes/simpleTableProps";

const TableHelper = {
  descendingComparator: (a: any, b: any, orderBy: string) => {
    if (b[orderBy] === undefined || b[orderBy] === null || b[orderBy] === "" || b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  },

  getComparator: <Key extends keyof any>(
    order: Order,
    orderBy: string
  ): ((a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number) => {
    return order === "desc"
      ? (a, b) => TableHelper.descendingComparator(a, b, orderBy)
      : (a, b) => -TableHelper.descendingComparator(a, b, orderBy);
  },

  tableSortAsync: (array: any[], comparator: (a: any, b: any) => number) => {
    const stabilizedThis = array.map((el, index) => [el, index] as [any, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  },
};

export default TableHelper;
